<style lang="less" scoped>
  .layout-copy {
    text-align: center;
    padding: 10px 0 20px;
    color: #9ea7b4;
  }
</style>
<template>
  <div class="layout-copy">
    <p>2017-2020 &copy; QU BOPS</p>
  </div>
</template>
<script>
  export default {
    data () {
      return {
      }
    }
  }
</script>



// WEBPACK FOOTER //
// CommonFooter.vue?2fd23b64